<template>
    <div>
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <b-container>
            <b-row>
                <b-col cols="12" md="5" lg="3">
                    <Sidenav/>
                </b-col>
                <b-col cols="12" md="7" lg="9">
                    <TextInfo :content="cms" :isArray="Array.isArray(cms)"/>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import TextInfo from "~/components/TextInfo";
import Breadcrumb from "~/components/Breadcrumb";
import Sidenav from "~/components/Sidenav";
export default{
    head() {
        return {
            title: this.title,
        }
    },
    components:{
        TextInfo,
        Breadcrumb,
        Sidenav
    },
    data: function () {
        return {
            cms: {
                name: '',
                text1: '',
            }
        }
    },
    computed:{
        breadcrumb(){
            let breadcrumb = [
                {
                    name: 'Home',
                    link: '/'
                },
                {
                    name: 'Central de atendimento',
                    link: null
                },
            ];
            return breadcrumb;
        },
    },
    async asyncData({params, res, $axios, req, app, error}) {
        try {
            const cms = await $axios.$get(`api/v1/cms/?page_alias=${params.alias}&limit=100`);
            if (cms.status !== 'success') {
                throw {statusCode: 404};
            }
            let cms_schema = {
                title: '',
                data: {
                    name: '',
                    text1: ''
                }
            }
            cms_schema = Object.assign({}, cms_schema, cms);
            if (cms_schema.data.name === '') {
                cms_schema.data.name = cms_schema.title
            }
            return {
                cms: cms_schema.data
            }
        } catch (e) {
            console.error(e)
        }
    }
}
</script>
